
























import 'vue-awesome/icons/plus'

export default
  name: 'mobile_accounts'
  components:
    stats:            require('components/inside/pages/accounts/stats.vue').default
    account_category: require('components/inside/pages/accounts/category.vue').default
    account_edit:     require('components/inside/pages/accounts/edit.vue').default
    account_category_edit: require('components/inside/pages/accounts/account_category_edit.vue').default
